// extracted by mini-css-extract-plugin
export default {"Title":"About_Title__ytjKT","Text":"About_Text__HmE6Q"};